module.exports = __webpack_public_path__ + "static/media/Warning.bd994017.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Toaster/Warning.svg
// module id = 4230
// module chunks = 1